import { render, staticRenderFns } from "./dyGoodsEdit.vue?vue&type=template&id=4c669c6d&"
import script from "./dyGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./dyGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./dyGoodsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports